// apps/web/src/components/dashboard/TrendDelta.tsx
//
// Compact delta readout for the Briefing Desk surfaces. Wraps the
// canonical `formatDelta` (CISO-surfaces spec §5.2) so colour always
// reflects good/bad news rather than raw direction.

import { cn } from '@/lib/utils'
import { formatDelta, type DeltaPolarity } from '@/lib/delta-format'

const COLOUR_CLASSES = {
  red: 'text-destructive',
  green: 'text-success',
  neutral: 'text-muted-foreground',
} as const

export interface TrendDeltaProps {
  value: number
  polarity: DeltaPolarity
  /** Formats the absolute value; defaults to plain number rendering. */
  format?: (abs: number) => string
  className?: string
}

export function TrendDelta(props: TrendDeltaProps) {
  const delta = formatDelta({ value: props.value, valuePolarity: props.polarity })
  const abs = Math.abs(props.value)
  const rendered = props.format ? props.format(abs) : String(abs)
  return (
    <span
      className={cn(
        'whitespace-nowrap font-mono text-xs font-medium',
        COLOUR_CLASSES[delta.colour],
        props.className,
      )}
    >
      {delta.arrow} {delta.sign}
      {rendered}
    </span>
  )
}
